import { render, staticRenderFns } from "./AudioPlayerVOD.vue?vue&type=template&id=270801b2&scoped=true&"
import script from "./AudioPlayerVOD.vue?vue&type=script&lang=js&"
export * from "./AudioPlayerVOD.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlayerVOD.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AudioPlayerVOD.vue?vue&type=style&index=1&id=270801b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270801b2",
  null
  
)

export default component.exports